import React from 'react';

import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import User from '@common/types/user/user';

import AppState from '@webapp/store/state';
import { getFullName } from '@webapp/store/user/selectors';

import Flex from '@components/layout/flex';
import Avatar from '@components/basics/avatar';
import Typography from '@components/basics/typography';
import GearIcon from '../../basics/icons/gear';
import NewMenuItem from '../new-menu-item';
import { LogoutUser } from '../../../store/auth/action-creators';
import { Dispatch } from 'redux';
import LogoutIcon from '../../basics/icons/logout';

interface UserInfoItemProps extends Partial<User> {
  className?: string;
}

const mapStateToProps = (state: AppState) => ({
  avatar: state.user.profile?.avatar,
  fullName: getFullName(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  logout: () => dispatch(new LogoutUser()),
});

const UserInfoItem: React.FC<UserInfoItemProps> = ({
  className,
  avatar,
  fullName,
  logout,
}) => {
  return (
    <nav className={className || ''}>
      <Flex alignItems="center" justifyContent="flex-start" gap={10}>
        <AvatarWrapper>
          <Avatar className="avatar" alt={fullName} src={avatar} size="24" />
        </AvatarWrapper>
        <div className="info">
          {fullName && (
            <Typography className="username">
              {fullName.length > 30 ? `${fullName.slice(0, 30)}...` : fullName}
            </Typography>
          )}
        </div>
      </Flex>
      <Flex
        className="menu"
        alignItems="flex-start"
        justifyContent="flex-start"
        gap={6}
        flexDirection="column"
        flexWrap="wrap"
      >
        <NewMenuItem icon={<GearIcon className="icon" />} active to="/user">
          <Translate id="DASHBOARD.ARTIST_MENU.USER.MANAGE" />
        </NewMenuItem>
        <NewMenuItem
          icon={<GearIcon className="icon" />}
          active
          to="/user/banking"
        >
          <Translate id="DASHBOARD.NEW_DASHBOARD.USER.MENU.WALLET" />
        </NewMenuItem>
        <NewMenuItem
          icon={<LogoutIcon className="icon" />}
          accent
          active
          onClick={logout}
        >
          <Translate id="USER_PROFILE.SIDEBAR.LOGOUT" />
        </NewMenuItem>
      </Flex>
    </nav>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(UserInfoItem)`
  cursor: pointer;
  width: 100%;
  position: relative;

  .avatar {
    flex-shrink: 0;
    height: 24px;
    width: 24px;
  }

  .info {
    .username {
      font-weight: 700;
      margin-bottom: 2px;
    }
    .personal {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }

  .icon {
    width: 14px;
    height: 14px;
  }

  .menu {
    padding: 20px 8px;
  }
`);

const AvatarWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    border: 2px solid ${({ theme }) => theme.colors.blueColor};
  }
`;
